import { appStyles } from './app.style';

export interface DropdownOption {
	id: number;
	label: string;
}

interface DropdownInAppProps {
	label?: string;
	options: DropdownOption[];
	value?: number;
	onChange?: (id: number) => void;
	disabled?: boolean;
	style?: React.CSSProperties;
	required?: boolean;
}

export const DropdownInApp = ({
	label,
	options,
	value,
	onChange,
	disabled = false,
	style = {},
	required = false
}: DropdownInAppProps) => {

	const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const selectedId = parseInt(e.target.value, 10);
		if (onChange) {
			onChange(selectedId);
		}
	};

	return (
		<div style={{ marginBottom: '1rem', width: '100%' }}>
			{label && 
				<label style={{
					display: 'block',
					marginBottom: '0.5rem',
					fontSize: '0.9rem',
					color: '#2d3748',
					fontWeight: '500'
				}}>
					{label}
					{required && <span style={{ color: '#e53e3e', marginLeft: '0.25rem' }}>*</span>}
				</label>
			}
			<select
				value={value !== undefined ? value : ''}
				onChange={handleChange}
				disabled={disabled}
				required={required}
				style={{
					...appStyles.input,
					width: '90%',
					cursor: disabled ? 'not-allowed' : 'pointer',
					backgroundColor: disabled ? '#f7fafc' : 'white',
					...style
				}}
			>
				<option value="">Seleccione una opción</option>
				{options.map((option) => (
					<option key={option.id} value={option.id}>
						{option.label}
					</option>
				))}
			</select>
		</div>
	);
};

